import { render, staticRenderFns } from "./CardInfo.vue?vue&type=template&id=04c56a4f&scoped=true&"
import script from "./CardInfo.vue?vue&type=script&lang=js&"
export * from "./CardInfo.vue?vue&type=script&lang=js&"
import style0 from "./CardInfo.vue?vue&type=style&index=0&id=04c56a4f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c56a4f",
  null
  
)

component.options.__file = "CardInfo.vue"
export default component.exports